module.exports = __webpack_public_path__ + "img/animat-rocket-color.9202f5d0.gif";